import { render, staticRenderFns } from "./DataElementFilters.vue?vue&type=template&id=8c886bde"
import script from "./DataElementFilters.vue?vue&type=script&lang=js"
export * from "./DataElementFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports